<template>
  <div class="dialog-ctr">
    <div class="alipay-wrap">
      <div class="closeBtn" @click="closeAlipay">
        <img :src="withclose" alt />
      </div>
      <img :src="alipayicon" alt class="alipayicon" />
      <div
        class="alipay-text-two"
        v-if="this.$store.state.alipayData['popType'] === 'POP_ONE'"
      >您有笔工资即将进账，绑定支付宝快速提现，秒到账！</div>
      <div class="alipay-text-one" v-else>
        您有
        <strong>{{this.$store.state.alipayData['amount']}}</strong> 元待提现，绑定支付宝快速提现，秒到账！
      </div>
      <a class="bind-btn" @click="gotoBind">前往绑定</a>
    </div>
  </div>
</template>
<script>
import withclose from "@/assets/imgs/withdrawal-close.png";
import alipayicon from "@/assets/imgs/alipayicon.png";

import { setPoint } from "@/utils/point";

export default {
  data() {
    return {
      withclose,
      alipayicon
    };
  },
  mounted() {
    this.Sensors();
  },
  methods: {
    closeAlipay() {
      if (this.$store.state.alipayData["popType"] === "POP_ONE") {
        this.setSensors("dialog_bind_ali", {
          interview_click: "绑定支付宝弹窗一-取消"
        });
      } else {
        this.setSensors("dialog_bind_ali", {
          interview_click: "绑定支付宝弹窗二-取消"
        });
      }
      this.$store.commit("SET_ALIPAY_SHOW", false);
    },
    gotoBind() {
      if (this.$store.state.alipayData["popType"] === "POP_ONE") {
        this.setSensors("dialog_bind_ali", {
          interview_click: "绑定支付宝弹窗一-前往绑定"
        });
      } else {
        this.setSensors("dialog_bind_ali", {
          interview_click: "绑定支付宝弹窗二-前往绑定"
        });
      }
      setPoint('1');
      this.$store.commit("SET_ALIPAY_SHOW", false);
      this.$router.push({ name: "bindAlipay" });
    },
    // 神策埋点 this.setSensors('h5_rixin',{'interview_click':'日薪打卡页弹窗-拆红包1'})
    Sensors() {
      if (this.$store.state.showAlipay) {
        if (this.$store.state.alipayData["popType"] === "POP_ONE") {
          this.setSensors("dialog_bind_ali", {
            interview_show: "绑定支付宝弹窗一"
          });
        } else {
          this.setSensors("dialog_bind_ali", {
            interview_show: "绑定支付宝弹窗二"
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/*弹框通用*/
.dialog-ctr {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  .alipay-wrap {
    width: 68%;
    height: 5.8rem;
    background: url("../assets/imgs/alipaybg.png") #ffffff no-repeat center;
    background-size: cover;
    border-radius: 0.2rem;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .closeBtn {
      position: absolute;
      right: 0;
      top: -0.58rem;
      img {
        display: inline-block;
        height: 0.44rem;
        width: 0.44rem;
      }
    }
    .alipayicon {
      display: inline-block;
      width: 2.28rem;
      height: 2.28rem;
    }
    .alipay-text-one,
    .alipay-text-two {
      width: 4rem;
      text-align: center;
      font-size: 0.28rem;
      font-weight: 400;
      line-height: 0.48rem;
      color: #05224b;
    }
    .bind-btn {
      width: 4rem;
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      text-align: center;
      color: #ffffff;
      background: url("../assets/imgs/btn-png.png") no-repeat center;
      background-size: contain;
    }
  }
}
</style>
